import styled, { css } from 'styled-components';
import { colors, MediaQuery } from '../../../../theme/style-helpers';

export const Container = styled.div`
    display: grid;
    grid-template-rows: max-content 350px;
    row-gap: 24px;

    ${MediaQuery.medium(css`
        grid-template-rows: 380px 450px;
        row-gap: 48px;
    `)};

    ${MediaQuery.xLarge(css`
        grid-template-rows: 556px;
        grid-template-columns: 1fr 1fr;
        column-gap: 40px;
        row-gap: unset;
    `)};
`;

export const TrackingHistory = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    max-height: 450px;
    overflow: auto;

    &::-webkit-scrollbar {
        width: 18px;
    }

    &::-webkit-scrollbar-thumb {
        box-shadow: inset 0 0 20px 20px #D9D9D6;
        border: solid 6px transparent;
        border-radius: 999px;
    }

    ${MediaQuery.medium(css`
        max-height: 380px;
    `)};

    ${MediaQuery.xLarge(css`
        max-height: 100%;
    `)};
    
`;

export const DateLabel = styled.div`
    background-color:#F9F9F9;
    padding: 12px 24px;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    color: ${colors.BLACK};

    ${MediaQuery.medium(css`
        font-size: 18px;
        padding: 12px 32px;
    `)};
`;

export const Hour = styled.p`
    margin: 0;
    font-weight: 600;
    font-size: 16px;
    line-height: 16px;
    color: ${colors.BLACK};
    grid-column: 1;
    grid-row: 2;
    justify-self: end;
`;

export const Circle = styled.div`
    box-sizing: border-box;
    border: 2px solid ${colors.BRAND_ORANGE};
    width: 16px;
    height: 16px;
    border-radius: 16px;
    grid-column: 2;
    grid-row: 2;
`;

export const LocationAndStatus = styled.button`
    grid-column: 3;
    grid-row: 2 / span 2;
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    border: none;
    text-align: left;
    background-color: transparent;
    cursor: pointer;
    width: max-content;

    &:focus {
        outline: none;
    }
`;

export const Status = styled.p`
    margin: 0;
    line-height: 150%;
    color: ${colors.BLACK};
    font-size: 16px;
    margin-top: -4px;
`;

export const Location = styled.p`
    margin: 0;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    color: #343A40;
`;

export const Line = styled.span`
    margin: 0;
    justify-self: center;
    width: 1px;
    height: 100%;
    background-color: ${colors.BRAND_ORANGE};
    grid-column: 2;
    grid-row: ${({ row }) => row || 'auto'};
    min-height: 32px;
    margin-left: -1px;
`;

export const Filler = styled.span`
    height: 32px;
    grid-column: 1 / -1;

    ${MediaQuery.medium(css`
        height: 28px;
    `)};

    ${MediaQuery.xLarge(css`
        height: 32px;
    `)};
`;

export const TouchPoint = styled.div`
    display: grid;
    grid-template-columns: 64px 16px auto;
    column-gap: 8px;
    grid-template-rows: max-content 16px auto 32px;
    padding: 0 24px;

    ${MediaQuery.medium(css`
        column-gap: 16px;
        padding: 0 60px;
    `)};

    ${Circle} {
        background-color: ${({ selected }) => (selected ? colors.BRAND_ORANGE : 'transparent')};
    }

    ${Status} {
        font-weight: ${({ selected }) => (selected ? '600' : '400')};
        ${MediaQuery.medium`
            font-size: ${({ selected }) => (selected ? '18px' : '16px')};
            margin-top: ${({ selected }) => (selected ? '-5px' : '-4px')};
    `};
    }
`;

export const MapContainer = styled.div`
    height: 100%;
`;
